import type { ReactNode } from "react";
import ReactPortableText from "react-portable-text";
import "./PortableText.css";

type PortableTextProps = {
  value: unknown;
  className: string;
  emphasisVariant?: "default" | "accent";
};

type SerializerProps = {
  children?: ReactNode;
};

const toPortableTextBlocks = (value: unknown): object[] => {
  if (!value) {
    return [];
  }

  return Array.isArray(value) ? value : [value];
};

export function PortableText({
  value,
  className,
  emphasisVariant = "default",
}: PortableTextProps) {
  const content = toPortableTextBlocks(value);

  if (content.length === 0) {
    return null;
  }

  const portableTextSerializers = {
    em: ({ children }: SerializerProps) => (
      <em
        className={`react-pdp__portable-em${
          emphasisVariant === "accent"
            ? " react-pdp__portable-em--accent"
            : ""
        }`}
      >
        {children}
      </em>
    ),
    normal: ({ children }: SerializerProps) => <p>{children}</p>,
    strong: ({ children }: SerializerProps) => <strong>{children}</strong>,
  };

  return (
    <ReactPortableText
      className={className}
      content={content}
      serializers={portableTextSerializers}
    />
  );
}
